import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import useRegistrationStore from "./useRegistrationStore"
import { useSuperUserStore } from "@stores/superUserStore"

export const useRegistrationCleanup = () => {
	const location = useLocation()
	const { setAgencyData, setTelephoneNumber, setAbtaNumber, setEmailAddress } =
		useRegistrationStore()
	const { setPhone, setAbta } = useSuperUserStore()

	useEffect(() => {
		const isOutsideRegistration =
			!location.pathname.startsWith("/register") &&
			!location.pathname.startsWith("/register-agency") &&
			!location.pathname.startsWith("/otp-verify")

		if (isOutsideRegistration) {
			setAgencyData(null)
			setTelephoneNumber("")
			setAbtaNumber("")
			setEmailAddress("")
		}
		const isOutsideSuperUser =
			!location.pathname.startsWith("/super-user") &&
			!location.pathname.startsWith("/super-user-agency-found")

		if (isOutsideSuperUser) {
			setPhone("")
			setAbta("")
		}
	}, [
		location.pathname,
		setAgencyData,
		setTelephoneNumber,
		setAbtaNumber,
		setPhone,
		setAbta,
		setEmailAddress
	])
}
